import React from 'react';

import { useInputFormCreator } from 'hooks/SuveyJS/useInputFormCreator';
import { SparkSurveyCreator } from 'external/SurveyJs';
import { TOOLBOX_ITEMS_TO_REMOVE } from 'constants/surveyJS';
import type { LocalizationText } from 'external/SurveyJs/SparkSurveyCreator';
import type { SurveyCreatorModel, ModifiedEvent } from 'survey-creator-core';

const localizationText: LocalizationText = {
  ed: {
    addNewQuestion: 'Add Question',
    surveyPlaceHolder:
      'The input form is empty. Drag an element from the toolbox or click the button below.',
  },
};

type InputFormCreatorProps = {
  formConfigJSON?: string;
  onclose?: () => void;
  onSurveyUpdate: (
    sender: SurveyCreatorModel,
    options: ModifiedEvent
  ) => Promise<void>;
};
function InputFormCreator({
  formConfigJSON = '',
  onclose,
  onSurveyUpdate,
}: InputFormCreatorProps) {
  const toolBoxItemsToRemove = TOOLBOX_ITEMS_TO_REMOVE.INPUT;

  const creator = useInputFormCreator({
    toolBoxItemsToRemove,
    defaultJSON: formConfigJSON,
    onSurveyUpdate,
    onclose,
  });

  if (!creator) {
    return null;
  }
  return (
    <SparkSurveyCreator creator={creator} localizationText={localizationText} />
  );
}

export default InputFormCreator;
